const STORE_LOCATOR_TIMINGS = {
  openingTime: "11AM",
  closingTime: "10PM",
};

export default STORE_LOCATOR_TIMINGS;



// WEBPACK FOOTER //
// ./src/constants/storelocator.js